import { Button } from '@lms/ui/button';
import { useToast } from '@lms/ui/use-toast';
import { Loader2Icon, Trash2Icon } from 'lucide-react';
import { useState } from 'react';
import { removeCurriculum } from '@/features/curriculums/curriculums-api';

// Ports app/[brand]/admin/curriculums/_components/remove-curriculum-button.tsx.
// The Next version used `useAsyncAction` with `refreshOnSuccess`; here we track
// the pending state locally and let the caller revalidate via SWR `onRemoved`.
export function RemoveCurriculumButton({
  curriculumId,
  onRemoved,
}: {
  curriculumId: number;
  onRemoved: () => void;
}) {
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    setIsLoading(true);
    try {
      const result = await removeCurriculum(curriculumId);
      if (result.ok) {
        onRemoved();
      } else {
        toast({ variant: 'destructive', description: result.error });
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      variant="destructive"
      size="icon"
      onClick={handleClick}
      disabled={isLoading}
    >
      {isLoading ? <Loader2Icon size="16" /> : <Trash2Icon size="16" />}
    </Button>
  );
}
